import React, { useEffect, useRef, useState } from 'react';

const VideoShowcase = () => {
  const videoRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  // Use the isInView state to play/pause the actual video element
  useEffect(() => {
    if (videoRef.current) {
      if (isInView) {
        videoRef.current.play().catch(error => {
            // Autoplay might be blocked by browsers if not muted
            console.log("Autoplay prevented:", error);
        });
      } else {
        videoRef.current.pause();
      }
    }
  }, [isInView]);

  const sectionStyle = {
    width: '100%',
    overflow: 'hidden',
    backgroundColor: '#000', // Keeps background clean while loading
  };

  const videoStyle = {
    width: '100%',
    height: '500px',
    display: 'block',
  };

  return (
    <section style={sectionStyle}>
      <video
        ref={videoRef}
        style={videoStyle}
        muted         // Required for most browsers to allow autoplay
        playsInline   // Better support for mobile browsers
        loop          // Optional: keeps the video going
        controls      // Optional: shows play/pause bar
      >
        <source src="/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </section>
  );
};

export default VideoShowcase;